import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'e5core-ui-monitor-sla-inventory',
  template: `
    <e5core-ui-monitor-sla-inventory-highcharts>
    </e5core-ui-monitor-sla-inventory-highcharts>
  `
})
export class E5coreUiMonitorSlaInventoryComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }


}
